import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, BarChart3, Compass, Plane, PhoneCall, Music, Car, UtensilsCrossed, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { trackEvent } from "../../lib/api";

export const VENTURE_ICONS = {
  chart: BarChart3, compass: Compass, plane: Plane, phone: PhoneCall,
  music: Music, car: Car, utensils: UtensilsCrossed, default: Sparkles,
};

export const VentureCard = ({ venture: v, index = 0 }) => {
  const Icon = VENTURE_ICONS[v.icon] || VENTURE_ICONS.default;
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="h-full"
    >
      <div data-testid={`venture-card-${v.slug}`}
        className="card-dark group flex h-full flex-col p-7 focus-within:border-violet/40">
        <div className="flex items-start justify-between">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/[0.08] bg-gradient-to-br from-violet/20 to-teal/10 transition-transform duration-500 group-hover:scale-105">
            <Icon size={22} className="text-teal" />
          </span>
          <span className="font-mono text-xs text-slate-500">{String(index + 1).padStart(2, "0")}</span>
        </div>
        <p className="eyebrow mt-6 !text-[10px]">{v.pillar}</p>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <h3 className="font-display text-xl font-semibold text-mist">{v.name}</h3>
          {v.status_label && (
            <span className={`rounded-full px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-widest ${v.status_label === "Live" ? "bg-teal/15 text-teal" : "bg-amber-400/15 text-amber-300"}`}>
              {v.status_label}
            </span>
          )}
          {v.ai_tag && <span className="rounded-full bg-violet/15 px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-widest text-violet">{v.ai_tag}</span>}
        </div>
        <p className="mt-2 font-display text-sm font-medium text-violet">{v.tagline}</p>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{v.summary}</p>
        <div className="mt-6 pt-2">
          {v.product_url ? (
            <a href={v.product_url} target="_blank" rel="noopener noreferrer" data-testid={`venture-explore-${v.slug}`}
              onClick={() => trackEvent("venture_click", { venture: v.slug, dest: v.product_url })}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-violet px-5 py-2.5 font-display text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-violet-hover">
              {v.cta_label || "Explore"} <ArrowUpRight size={15} />
            </a>
          ) : (
            <Link to={`/ventures/${v.slug}`} data-testid={`venture-enquire-${v.slug}`}
              onClick={() => trackEvent("venture_click", { venture: v.slug, dest: "enquiry" })}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-display text-sm font-semibold text-mist transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-teal/50 hover:bg-white/5">
              {v.cta_label || "Enquire"} <ArrowRight size={15} />
            </Link>
          )}
        </div>
      </div>
    </motion.div>
  );
};
